/* ICAO exercise pages (picture description, readback trainer, non-routine speaking).
   Markup is server-rendered and indexable; this script adds recording, reveal, tabs, scoring,
   the readback checker and the optional lead form. Recordings never leave the browser. */
(function (root) {
  "use strict";

  /* ================= Readback checker (pure; also run under Node for tests) ================= */
  var NUM = { zero: "0", one: "1", wun: "1", two: "2", too: "2", three: "3", tree: "3", four: "4", fower: "4", five: "5", fife: "5", six: "6", seven: "7", eight: "8", ait: "8", nine: "9", niner: "9" };
  var DOT = { decimal: 1, point: 1, dayseemal: 1 };
  var SIDE = { l: "l", left: "l", r: "r", right: "r", c: "c", center: "c", centre: "c" };
  function isNum(t) { return /^\d+(\.\d+)?$/.test(t); }

  function normalize(text) {
    var s = String(text || "").toLowerCase()
      .replace(/(\d),(\d{3})/g, "$1$2")
      .replace(/(\d)\s*\.\s*(\d)/g, "$1.$2")
      .replace(/flight\s*level/g, " fl ")
      .replace(/tousand/g, "thousand")
      .replace(/[,;:\/]/g, " | ")
      .replace(/[^a-z0-9.|\s]/g, " ")
      .replace(/\.(?!\d)/g, " ").replace(/(^|[^\d])\./g, "$1 ")
      .replace(/([a-z])(\d)/g, "$1 $2").replace(/(\d)([a-z])/g, "$1 $2");
    var raw = s.split(/\s+/).filter(Boolean).map(function (t) { return NUM[t] || (DOT[t] ? "." : t); });
    var out = [], i = 0;
    while (i < raw.length) {
      if (/^[\d.]+$/.test(raw[i]) && raw[i] !== ".") {
        var run = raw[i]; i++;
        // spoken digits ("two six zero") join into one number; a typed multi-digit number stands alone
        if (/^\d$/.test(run)) while (i < raw.length && (/^\d$/.test(raw[i]) || raw[i] === ".")) { run += raw[i]; i++; }
        run = run.replace(/\.+$/, "");
        if (raw[i] === "thousand" && /^\d+$/.test(run)) {
          var n = +run * 1000; i++;
          if (i + 1 < raw.length && /^\d+$/.test(raw[i]) && raw[i + 1] === "hundred") { n += +raw[i] * 100; i += 2; }
          run = String(n);
        } else if (raw[i] === "hundred" && /^\d+$/.test(run)) { run = String(+run * 100); i++; }
        out.push(run);
      } else { if (raw[i] !== "." && raw[i] !== "|") out.push(raw[i]); i++; }
    }
    return out;
  }

  function sameValue(want, got) {
    var w = /^(\d+)([lrc]?)$/.exec(want), g = /^(\d+)([lrc]?)$/.exec(got);
    if (w && w[2]) return !!g && +w[1] === +g[1] && w[2] === g[2];
    return parseFloat(want) === parseFloat(got);
  }

  function valueAfter(tokens, at) {
    for (var j = at; j < tokens.length && j < at + 5; j++) {
      if (isNum(tokens[j])) return tokens[j] + (SIDE[tokens[j + 1]] || "");
    }
    return null;
  }

  function checkField(field, tokens) {
    var line = " " + tokens.join(" ") + " ";
    if (field.all) {
      var miss = field.all.filter(function (w) {
        return !w.split("|").some(function (alt) { return line.indexOf(" " + normalize(alt).join(" ") + " ") !== -1; });
      });
      return { ok: !miss.length, got: null };
    }
    var firstGot = null;
    for (var k = 0; k < field.key.length; k++) {
      var key = normalize(field.key[k]);
      for (var i = 0; i <= tokens.length - key.length; i++) {
        if (tokens.slice(i, i + key.length).join(" ") !== key.join(" ")) continue;
        var got = valueAfter(tokens, i + key.length);
        if (got === null) continue;
        if (sameValue(field.v, got)) return { ok: true, got: got };
        if (firstGot === null) firstGot = got;
      }
    }
    if (firstGot === null) {
      for (var t = 0; t < tokens.length; t++) if (isNum(tokens[t]) && sameValue(field.v, tokens[t] + (SIDE[tokens[t + 1]] || ""))) return { ok: true, got: tokens[t] };
    }
    return { ok: false, got: firstGot };
  }

  function checkReadback(item, text) {
    var tokens = normalize(text);
    return item.fields.map(function (f) { var r = checkField(f, tokens); return { k: f.k, show: f.show, ok: r.ok, got: r.got }; });
  }

  var api = { normalize: normalize, checkReadback: checkReadback };
  if (typeof module !== "undefined" && module.exports) { module.exports = api; return; }
  if (typeof document === "undefined") return;

  /* ================= Shared helpers ================= */
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function track(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* optional */ } }
  function goTo(el) { if (!el) return; el.scrollIntoView({ block: "start", behavior: reduce ? "auto" : "smooth" }); if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1"); el.focus({ preventScroll: true }); }

  var main = $("[data-ex]");
  if (!main) return;
  var kind = main.getAttribute("data-ex");
  var audioBase = (main.getAttribute("data-audio-base") || "").replace(/\/+$/, "");

  /* One audio at a time */
  document.addEventListener("play", function (e) { $$("audio").forEach(function (a) { if (a !== e.target) a.pause(); }); }, true);
  /* Audio that fails to load gets a visible note instead of a dead player */
  $$("audio[data-ex-audio]").forEach(function (a) {
    a.addEventListener("error", function () {
      if (a.nextElementSibling && a.nextElementSibling.classList.contains("ex-audio-err")) return;
      var p = document.createElement("p"); p.className = "ex-audio-err"; p.textContent = "This recording could not load. Check your connection and reload the page.";
      a.insertAdjacentElement("afterend", p);
    }, true);
  });

  /* ---- Tabs (model answers by level) ---- */
  $$("[role=tablist]").forEach(function (list) {
    var tabs = $$("[role=tab]", list);
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab; t.setAttribute("aria-selected", on ? "true" : "false"); t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute("aria-controls")); if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { select(t); });
      t.addEventListener("keydown", function (e) {
        var n = e.key === "ArrowRight" ? i + 1 : e.key === "ArrowLeft" ? i - 1 : e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 : null;
        if (n === null) return; e.preventDefault(); select(tabs[(n + tabs.length) % tabs.length], true);
      });
    });
    select(tabs.filter(function (t) { return t.getAttribute("aria-selected") === "true"; })[0] || tabs[0]);
  });

  /* ---- Reveal model answers (hidden only once JS runs, so the text stays indexable) ---- */
  $$("[data-ex-reveal-target]").forEach(function (box) { box.hidden = true; });
  $$("[data-ex-reveal]").forEach(function (btn) {
    btn.hidden = false;
    btn.addEventListener("click", function () {
      var box = document.getElementById(btn.getAttribute("data-ex-reveal"));
      if (!box) return;
      box.hidden = false; btn.hidden = true;
      var h = $("h4, h3, [data-ex-focus]", box); goTo(h || box);
      var card = btn.closest("[data-ex-item]"); if (card) card.classList.add("is-revealed");
      track("ex_reveal", { page: kind, id: card ? card.id : "" });
      updateProgress();
    });
  });

  /* ---- Local recorder: 60/90 s, MediaRecorder, blob URL, nothing uploaded ---- */
  var canRecord = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);
  $$("[data-ex-rec]").forEach(function (box) {
    var btn = $("[data-rec-btn]", box), label = $("[data-rec-label]", box), time = $("[data-rec-time]", box), out = $("[data-rec-out]", box), note = $("[data-rec-note]", box);
    var limit = +box.getAttribute("data-limit") || 60;
    box.hidden = false;
    if (!canRecord) { btn.disabled = true; note.textContent = "Recording is not available in this browser. Answer aloud with a timer instead, then compare with the model answers."; return; }
    var mr = null, stream = null, chunks = [], t0 = 0, tick = null, url = null;
    function fmt(s) { s = Math.max(0, Math.round(s)); return "0:" + (s < 10 ? "0" : "") + s; }
    function fmtLong(s) { s = Math.max(0, Math.round(s)); return Math.floor(s / 60) + ":" + (s % 60 < 10 ? "0" : "") + (s % 60); }
    time.textContent = fmtLong(limit);
    function stop() { if (mr && mr.state !== "inactive") mr.stop(); }
    btn.addEventListener("click", function () {
      if (mr && mr.state === "recording") { stop(); return; }
      note.textContent = "";
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
        stream = s; chunks = [];
        try { mr = new MediaRecorder(s); } catch (e) { note.textContent = "Recording could not start in this browser."; s.getTracks().forEach(function (t) { t.stop(); }); return; }
        mr.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
        mr.onstop = function () {
          clearInterval(tick); stream.getTracks().forEach(function (t) { t.stop(); });
          box.classList.remove("is-live"); btn.setAttribute("aria-pressed", "false"); label.textContent = "Record again";
          if (url) URL.revokeObjectURL(url);
          url = URL.createObjectURL(new Blob(chunks, { type: mr.mimeType || "audio/webm" }));
          out.innerHTML = '<p class="ex-rec-cap">Your answer (' + fmtLong((Date.now() - t0) / 1000) + ") — kept on this device only</p>";
          var a = document.createElement("audio"); a.controls = true; a.src = url; a.setAttribute("aria-label", "Your recorded answer"); out.appendChild(a);
          time.textContent = fmtLong(limit);
          track("ex_record", { page: kind });
          var card = box.closest("[data-ex-item]"); var rv = card && $("[data-ex-reveal]", card); if (rv && !rv.hidden) rv.focus();
        };
        mr.start(); t0 = Date.now();
        box.classList.add("is-live"); btn.setAttribute("aria-pressed", "true"); label.textContent = "Stop recording";
        tick = setInterval(function () { var left = limit - (Date.now() - t0) / 1000; time.textContent = fmtLong(left); if (left <= 0) stop(); }, 250);
      }).catch(function () { note.textContent = "Microphone access was blocked. Allow it in your browser settings, or answer aloud and compare with the model answers."; });
    });
  });

  /* ---- Progress + result screen for picture / non-routine pages ---- */
  var items = $$("[data-ex-item]");
  var progress = $("[data-ex-progress]");
  function updateProgress() {
    // Mixed kit pages count all item types in sfp2-ex-kit.js.
    if (kind === "kit" || !progress) return;
    var done = items.filter(function (c) { return c.classList.contains("is-revealed"); }).length;
    progress.textContent = done + " of " + items.length + " done";
    var bar = $("[data-ex-bar]"); if (bar) bar.style.width = (done / items.length * 100) + "%";
  }
  updateProgress();

  var result = $("[data-ex-result]");
  var finishBtns = $$("[data-ex-finish]");
  function showResult() {
    if (!result) return;
    var body = $("[data-ex-result-body]", result);
    body.innerHTML = kind === "picture" ? pictureSummary() : kind === "nonroutine" ? nonroutineSummary() : "";
    result.hidden = false; goTo($("h2", result));
    track("ex_result", { page: kind });
  }
  finishBtns.forEach(function (b) { b.addEventListener("click", showResult); });

  function pictureSummary() {
    var counts = { "3": 0, "4": 0, "5": 0, "6": 0 }, rated = 0;
    items.forEach(function (c) { var r = $("input[data-ex-rate]:checked", c); if (r) { counts[r.value]++; rated++; } });
    var done = items.filter(function (c) { return c.classList.contains("is-revealed"); }).length;
    if (!rated) return '<p class="ex-result-lede">You worked through <strong>' + done + " of " + items.length + "</strong> scenes. Rate each answer against the model answers next time to see where you sit between Level 4 and Level 6.</p>";
    var low = ["3", "4", "5", "6"].filter(function (k) { return counts[k]; })[0];
    var rows = ["6", "5", "4", "3"].map(function (k) {
      return '<div class="ex-dist-row"><dt>' + (k === "3" ? "Below Level 4" : "Level " + k) + '</dt><dd><span class="ex-dist-bar" style="--w:' + (counts[k] / rated * 100) + '%"></span><span class="ex-dist-n">' + counts[k] + "</span></dd></div>";
    }).join("");
    return '<p class="ex-result-lede">You rated <strong>' + rated + " of " + items.length + "</strong> answers. Your lowest self-rating was <strong>" + (low === "3" ? "below Level 4" : "Level " + low) + "</strong> — and in the real test, your overall level is the lowest of your six skill scores, not an average.</p><dl class=\"ex-dist\">" + rows + "</dl>";
  }

  function nonroutineSummary() {
    var crit = ["Pronunciation", "Structure", "Vocabulary", "Fluency", "Comprehension", "Interactions"], got = {}, tot = {};
    crit.forEach(function (c) { got[c] = 0; tot[c] = 0; });
    $$("input[data-ex-crit]").forEach(function (i) { var c = i.getAttribute("data-ex-crit"); tot[c]++; if (i.checked) got[c]++; });
    var any = crit.some(function (c) { return got[c]; });
    if (!any) return '<p class="ex-result-lede">Tick the checklist items you managed in each situation, then finish again to see your weakest ICAO criterion.</p>';
    var weakest = crit.slice().sort(function (a, b) { return got[a] / tot[a] - got[b] / tot[b]; })[0];
    var rows = crit.map(function (c) {
      var pct = tot[c] ? got[c] / tot[c] * 100 : 0;
      return '<div class="ex-dist-row' + (c === weakest ? " is-weak" : "") + '"><dt>' + c + '</dt><dd><span class="ex-dist-bar" style="--w:' + pct + '%"></span><span class="ex-dist-n">' + got[c] + "/" + tot[c] + "</span></dd></div>";
    }).join("");
    return '<p class="ex-result-lede">Your weakest criterion today: <strong>' + weakest + "</strong>. That matters — the overall ICAO level is the lowest of the six scores, so one weak skill sets your level.</p><dl class=\"ex-dist\">" + rows + "</dl>";
  }

  /* ================= Readback trainer ================= */
  var rbRoot = $("[data-rb]");
  if (rbRoot) (function () {
    var data = JSON.parse($("#ex-rb-data").textContent);
    var stage = $("[data-rb-stage]", rbRoot), sessionEl = $("[data-rb-session]", rbRoot);
    var params = new URLSearchParams(location.search);
    var seed = parseInt(params.get("seed"), 10);
    if (!(seed > 0 && seed < 100000)) seed = 1000 + Math.floor(Math.random() * 9000);
    var level = 1, order = [], pos = 0, score = [], fieldStats = {};

    function rng(a) { return function () { a = (a + 0x6d2b79f5) >>> 0; var t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }
    function shuffled(list, s) { var r = rng(s), a = list.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(r() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    function setSession() {
      sessionEl.innerHTML = 'Session <strong>' + seed + '</strong> · same code, same order. <a href="?seed=' + seed + '#trainer">Link to this session</a>';
    }
    function startLevel(l) {
      level = l; pos = 0; score = []; fieldStats = {};
      order = shuffled(data.items.filter(function (it) { return it.level === l; }), seed * 7 + l);
      $$("[data-rb-level]", rbRoot).forEach(function (b) { b.setAttribute("aria-pressed", +b.getAttribute("data-rb-level") === l ? "true" : "false"); });
      render(); track("rb_start", { level: l, seed: seed });
    }
    function bar() { return '<div class="practice-progress" aria-hidden="true"><span style="width:' + (pos / order.length * 100) + '%"></span></div>'; }
    function render() {
      var it = order[pos];
      stage.innerHTML = bar() +
        '<article class="practice-sheet rb-card" aria-labelledby="rb-h">' +
        '<header class="practice-sheet-head"><p class="practice-ref">LEVEL ' + level + ' · CLEARANCE ' + (pos + 1) + " OF " + order.length + " · " + ["", "SLOW", "NORMAL SPEED", "FAST"][level] + '</p><h3 id="rb-h" tabindex="-1">Listen, then type your readback</h3></header>' +
        '<div class="practice-audio"><audio controls preload="auto" data-ex-audio src="' + audioBase + "/ex/rb-" + it.id + '.mp3" aria-label="Clearance ' + (pos + 1) + '"></audio></div>' +
        '<form class="rb-form" novalidate><label for="rb-in">Your readback</label>' +
        '<textarea id="rb-in" rows="3" inputmode="text" autocomplete="off" autocorrect="off" autocapitalize="characters" spellcheck="false" enterkeyhint="done" aria-describedby="rb-hint"></textarea>' +
        '<p id="rb-hint" class="practice-help">Digits or words both work: “FL260” or “flight level two six zero”. Include your call sign.</p>' +
        '<div class="practice-actions"><button class="btn btn--seal" type="submit">Check readback</button></div></form>' +
        '<div data-rb-out aria-live="polite"></div></article>';
      var form = $("form", stage), out = $("[data-rb-out]", stage);
      // keep the input above the on-screen keyboard; Enter (without Shift) checks the readback
      var ta = $("textarea", form);
      ta.addEventListener("focus", function () { setTimeout(function () { ta.scrollIntoView({ block: "center", behavior: reduce ? "auto" : "smooth" }); }, 300); });
      ta.addEventListener("keydown", function (e) { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); if (form.requestSubmit) form.requestSubmit(); else $("button", form).click(); } });
      var audio = $("audio", stage);
      audio.addEventListener("error", function () { out.innerHTML = '<p class="ex-audio-err">This recording could not load. Check your connection and reload the page.</p>'; });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var text = $("textarea", form).value;
        if (!text.trim()) { out.innerHTML = '<p class="practice-status is-error">Type what you would read back first.</p>'; $("textarea", form).focus(); return; }
        var res = checkReadback(it, text), ok = res.filter(function (r) { return r.ok; }).length;
        score.push({ ok: ok, total: res.length });
        res.forEach(function (r) { var s = fieldStats[r.k] || (fieldStats[r.k] = { ok: 0, total: 0 }); s.total++; if (r.ok) s.ok++; });
        $("button", form).disabled = true; $("textarea", form).readOnly = true;
        out.innerHTML =
          '<p class="rb-score"><strong>' + ok + " of " + res.length + "</strong> items correct" + (ok === res.length ? " — clean readback." : ".") + "</p>" +
          '<table class="rb-table"><caption class="visually-hidden">Readback check, item by item</caption><thead><tr><th scope="col">Item</th><th scope="col">Cleared</th><th scope="col">Your readback</th></tr></thead><tbody>' +
          res.map(function (r) {
            return '<tr class="' + (r.ok ? "is-ok" : "is-bad") + '"><th scope="row">' + esc(r.k) + "</th><td>" + esc(r.show) + "</td><td>" +
              (r.ok ? '<span class="rb-mark">✓</span> Correct' : '<span class="rb-mark">✗</span> ' + (r.got ? "You wrote " + esc(r.got.toUpperCase()) : "Missing")) + "</td></tr>";
          }).join("") + "</tbody></table>" +
          '<div class="rb-model"><p class="kicker">CORRECT READBACK</p><p>' + esc(it.readback) + '</p><p class="rb-heard"><span>Clearance heard:</span> ' + esc(it.say) + "</p></div>" +
          '<div class="practice-actions"><button type="button" class="btn btn--paper" data-rb-next>' + (pos + 1 < order.length ? "Next clearance" : "See my result") + "</button></div>";
        $("[data-rb-next]", out).addEventListener("click", function () { pos++; if (pos < order.length) { render(); goTo($("#rb-h")); } else finish(); });
        ta.blur();
        out.scrollIntoView({ block: "start", behavior: reduce ? "auto" : "smooth" });
        $("[data-rb-next]", out).focus({ preventScroll: true });
        track("rb_check", { id: it.id, ok: ok, total: res.length });
      });
    }
    function finish() {
      var ok = 0, total = 0; score.forEach(function (s) { ok += s.ok; total += s.total; });
      var pct = Math.round(ok / total * 100);
      var weak = Object.keys(fieldStats).sort(function (a, b) { return fieldStats[a].ok / fieldStats[a].total - fieldStats[b].ok / fieldStats[b].total; });
      var weakest = weak.filter(function (k) { return fieldStats[k].ok < fieldStats[k].total; });
      stage.innerHTML = "";
      var body = $("[data-ex-result-body]", result);
      body.innerHTML = '<p class="ex-result-score"><span>' + pct + '%</span> of items read back correctly at Level ' + level + " (" + ok + "/" + total + ").</p>" +
        (weakest.length ? '<p class="ex-result-lede">Work on: <strong>' + weakest.slice(0, 3).map(esc).join(", ") + "</strong>.</p>" : '<p class="ex-result-lede">No errors on this level — try the next speed.</p>') +
        '<dl class="ex-dist">' + weak.map(function (k) { var s = fieldStats[k]; return '<div class="ex-dist-row' + (s.ok < s.total ? " is-weak" : "") + '"><dt>' + esc(k) + '</dt><dd><span class="ex-dist-bar" style="--w:' + (s.ok / s.total * 100) + '%"></span><span class="ex-dist-n">' + s.ok + "/" + s.total + "</span></dd></div>"; }).join("") + "</dl>" +
        '<div class="practice-actions">' + (level < 3 ? '<button type="button" class="btn btn--paper" data-rb-go="' + (level + 1) + '">Continue to Level ' + (level + 1) + "</button>" : "") + '<button type="button" class="btn btn--paper" data-rb-go="' + level + '">Retry Level ' + level + "</button></div>";
      $$("[data-rb-go]", body).forEach(function (b) { b.addEventListener("click", function () { result.hidden = true; startLevel(+b.getAttribute("data-rb-go")); goTo($("#trainer")); }); });
      result.hidden = false; goTo($("h2", result));
      track("ex_result", { page: kind, level: level, pct: pct });
    }
    $$("[data-rb-level]", rbRoot).forEach(function (b) { b.addEventListener("click", function () { result.hidden = true; startLevel(+b.getAttribute("data-rb-level")); goTo($("#rb-h")); }); });
    $("[data-rb-new]", rbRoot).addEventListener("click", function () { seed = 1000 + Math.floor(Math.random() * 9000); setSession(); startLevel(level); });
    rbRoot.hidden = false;
    setSession(); startLevel(1);
  })();

  /* ================= Lead form: POST {api}/api/leads ================= */
  $$("form[data-ex-lead]").forEach(function (form) {
    var status = $("[data-ex-lead-status]", form), btn = $("button[type=submit]", form), email = $("input[type=email]", form), consent = $("input[name=consent]", form);
    function say(msg, bad) { status.textContent = msg; status.classList.toggle("is-error", !!bad); }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var api = (form.getAttribute("data-api") || "").replace(/\/+$/, "");
      var value = email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) { email.setAttribute("aria-invalid", "true"); say("Enter a valid email address, e.g. name@example.com.", true); email.focus(); return; }
      email.removeAttribute("aria-invalid");
      if (!consent.checked) { say("Tick the box so we can email you.", true); consent.focus(); return; }
      btn.disabled = true; btn.setAttribute("aria-busy", "true"); say("Sending…");
      var ctrl = "AbortController" in window ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
      fetch(api + "/api/leads", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value, source: "drills", consent: true, meta: { page: form.getAttribute("data-page") } }),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        if (res.ok) { form.classList.add("is-sent"); say("Thanks — if that address is valid, new exercises are on their way. Check your inbox and the Promotions or Spam folder."); track("ex_lead", { page: kind }); return; }
        if (res.status === 400) { say("That email address was not accepted. Check it and try again.", true); return; }
        if (res.status === 429) { say("Too many requests. Please try again tomorrow.", true); return; }
        throw new Error("HTTP " + res.status);
      }).catch(function () { say("We could not sign you up right now. Please try again in a few minutes.", true); })
        .then(function () { clearTimeout(timer); btn.disabled = form.classList.contains("is-sent"); btn.removeAttribute("aria-busy"); });
    });
  });

  $$("[data-book-cta]").forEach(function (a) { a.addEventListener("click", function () { track("ex_book_cta", { page: kind, where: a.getAttribute("data-where") || "" }); }); });
})(this);
